import { render, staticRenderFns } from "./CalendarAsideTest.vue?vue&type=template&id=9d0ff2f4&scoped=true&"
import script from "./CalendarAsideTest.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0ff2f4",
  null
  
)

export default component.exports